<template>
  <li :class="{ phone: chatOrPhone === 'PHONE' }">
    <span
      class="star-wrapper small"
      v-if="
        client.type + client.id in sendingFavRequest &&
          sendingFavRequest[client.type + client.id] === true
      "
    >
      <div class="loader-small"></div>
    </span>
    <span class="star-wrapper" @click.stop="toggleFavourite" v-else>
      <img :src="starIcon" v-if="client.favourite_id !== 0" />
      <img :src="starEmptyIcon" v-else />
    </span>
    <span class="user-name-wrapper" :class="{ chat: chatOrPhone === 'CHAT' }">{{
      client.name
    }}</span>
    <span
      class="dropdown-wrapper"
      :class="{
        'add-phone': !(
          filteredPhones &&
          filteredPhones.length > 0 &&
          addPhoneUser === false
        )
      }"
      v-if="chatOrPhone === 'PHONE'"
    >
      <span
        v-if="
          (filteredPhones && filteredPhones.length > 0) ||
            client.type === 'person' ||
            client.type === 'other_event'
        "
      >
        <transition-group name="fade-full" mode="out-in">
          <span
            key="1"
            v-show="
              filteredPhones &&
                filteredPhones.length > 0 &&
                addPhoneUser === false
            "
          >
            <label class="phone-dropdown-design" key="1">
              <select
                class="custom-select"
                v-model="selectedPhone"
                @change="sendAddSelectedPhoneRequestLocal"
              >
                <option value="0" disabled>Select phone</option>
                <option
                  v-for="(value, index) in filteredPhones"
                  :key="index"
                  :value="value"
                  >{{ value }}</option
                >
              </select>
            </label>

            <img
              ref="plusIcon"
              class="img-plus"
              :src="plusIcon"
              v-show="
                filteredPhones &&
                  filteredPhones.length < 4 &&
                  (client.type === 'person' || client.type === 'other_event') &&
                  addPhoneUser === false
              "
            />
          </span>
          <div
            key="2"
            class="no-phone-div"
            v-show="
              !(
                filteredPhones &&
                filteredPhones.length > 0 &&
                addPhoneUser === false
              )
            "
          >
            <!-- ios input -->
            <input
              v-if="iOS"
              v-model="phone"
              @keydown="setPhone"
              @blur="addPhoneLocal"
              type="text"
              pattern="[0-9]*"
              placeholder="Add phone"
              class="add-phone"
              ref="phone"
              autocomplete="off"
              maxlength="12"
            />
            <!-- android and others input -->
            <input
              v-else
              v-model="phone"
              @keypress.enter="addPhoneLocal"
              @keydown="setPhone"
              @blur="hideAddPhoneUser"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              placeholder="Add phone"
              class="add-phone"
              ref="phone"
              autocomplete="off"
              maxlength="12"
            />
            <!-- Cancel button -->
            <a
              v-if="phone !== ''"
              data-v-6b6a9972
              href="#"
              @click.prevent="hideAddPhoneUser"
              class="search-close-icon"
            >
              <object
                data-v-6b6a9972
                :data="cancelSvg"
                type="image/svg+xml"
              ></object>
            </a>
          </div>
        </transition-group>
      </span>
      <span class="no-contact" v-else>No phone numbers found</span>
    </span>

    <!-- No phone selected -->
    <span
      class="call-wrapper text-right"
      v-if="
        selectedPhone === 0 &&
          chatOrPhone === 'PHONE' &&
          !addPhoneUser &&
          filteredPhones.length > 0
      "
    ></span>

    <!-- Chat -->
    <span class="call-wrapper text-right" v-else-if="chatOrPhone === 'CHAT'">
      <a class="btn-chat" href="#" @click.prevent="goToChat(client)">Chat</a>
    </span>

    <!-- Phone selected -->
    <span
      class="call-wrapper text-right"
      v-else-if="!addPhoneUser && filteredPhones.length > 0"
    >
      <a :href="`tel:${selectedPhone}`" class="btn-chat">Call</a>
    </span>
  </li>
</template>

<script>
import { addPhoneMixin } from "../../mixins/addPhoneMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [addPhoneMixin],
  props: {
    client: Object,
    chatOrPhone: String
  },
  data() {
    return {
      selectedPhone: 0,
      starIcon: require("../../assets/img/m_favorites.png"),
      starEmptyIcon: require("../../assets/img/m_favorites-empty.png"),
      plusIcon: require("../../assets/img/m_plus.png"),
      cancelSvg: require("../../assets/svg/cancel.svg")
    };
  },
  computed: {
    ...mapGetters("favourites", {
      sendingFavRequest: "getSendingFavRequest"
    }),
    filteredPhones() {
      if (this.client) {
        return this.client.phone.filter(phone => {
          return phone !== "" && phone !== null;
        });
      } else {
        return false;
      }
    },
    clientId() {
      return this.client.type === "person"
        ? this.client.id
        : this.client.type + "." + this.client.id;
    },
    by() {
      return this.client.type === "person" ? "CLIENTS" : "OTHERS";
    },
    focus() {
      return this.filteredPhones.length !== 0;
    }
  },
  methods: {
    toggleFavourite() {
      if (this.client.favourite_id === 0) {
        this.sendAddFavouritesRequest(this.client);
      } else {
        this.sendRemoveFavouritesRequest(this.client);
      }
    },
    sendAddSelectedPhoneRequestLocal() {
      this.addSelectedPhone({
        ...this.client,
        phone: this.selectedPhone
      });
    },
    goToChat(user) {
      // Step 1: Check if group
      if (user.type === "group_appointment") {
        return this.$router.push(`/messenger/group/${user.id}`);
      }
      this.setSelectedUserId(parseInt(user.user_id));
      this.$router.push("/messenger");
    }
  },
  created() {
    if (this.filteredPhones) {
      for (let i = 0; i < this.filteredPhones.length; i++) {
        if (this.filteredPhones[i] === this.client.selected_phone) {
          this.selectedPhone = this.filteredPhones[i];
        }
      }
    }
  },
  mounted() {
    if (this.$refs.plusIcon !== undefined) {
      this.$refs.plusIcon.addEventListener("click", event => {
        this.addPhoneUser = true;
        this.$nextTick(() => {
          event.target.parentElement.parentElement.children[1].children[0].focus();
        });
      });
    }
  }
};
</script>

<style scoped>
span.add-phone {
  width: 100% !important;
}

.loader-small {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #d26d13;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.5s linear infinite;
}

.small {
  width: 10px;
}

.no-contact {
  margin: 10px 0px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;
  color: darkgray;
}

a.disabled {
  background-color: gray !important;
}

.add-phone {
  width: calc(100% - 127px);
}

.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.3s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.search-close-icon {
  display: block !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 580px) {
  section .phone-list-wrapper ul li span.dropdown-wrapper {
    position: relative;
  }
  section .phone-list-wrapper ul li span.dropdown-wrapper .img-plus {
    position: absolute;
    top: 6px;
  }
}
@media (max-width: 440px) {
  section .phone-list-wrapper ul li span.dropdown-wrapper .img-plus {
    position: relative;
    top: 0px;
  }
  section .call-wrapper a {
    padding: 4px 0.2em 4px 0.2em !important;
    font-size: 13px;
  }

  section .call-wrapper a {
    padding: 4px 0.2em 4px 0.2em !important;
    font-size: 13px;
  }
}
</style>
